type HeroStatProps = {
  value: string
  label: string
}

export const HeroStat = ({ value, label }: HeroStatProps) => {
  return (
    <div className="hero-stat">
      <div className="hero-stat-value">{value}</div>
      <div className="hero-stat-label">{label}</div>
    </div>
  )
}
